"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebounce = void 0;

var useDebounce = function useDebounce(ref, eventHandler, debounceTime) {
  return function () {
    if (ref.current) {
      var localArgs = arguments;

      if (ref.current.debouncedEventTimer) {
        clearTimeout(ref.current.debouncedEventTimer);
      }

      ref.current.debouncedEventTimer = setTimeout(function () {
        return eventHandler.apply(null, localArgs);
      }, debounceTime);
    }
  };
};

exports.useDebounce = useDebounce;